import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedEvaluationService {
  private reloadDataSubject = new Subject<void>();
  public reloadData = this.reloadDataSubject.asObservable();
  
  triggerReload(): void {
    this.reloadDataSubject.next();
  }
}
